import React, { useEffect, useState } from "react";
import {
  Menu,
  X,
  ChevronDown,
  Search,
  ChevronDownIcon,
  Bell,
} from "lucide-react";
import {
  ChevronRight,
  Facebook,
  Instagram,
  Twitter,
  Youtube,
} from "lucide-react";
import {
  MenuButton,
  MenuItem,
  MenuItems,
  Menu as MyMenu,
} from "@headlessui/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useStorage } from "../../hooks/useLocalStorage";
import { getData } from "../../api/api"; 
const userNavigation = [
  { name: "My Profile", href: "/user/profile" },
  { name: "Courses", href: "/user/course" },
  { name: "Logout", href: "/login" },
];
const Header = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [token, setToken, loadToken] = useStorage("accessToken", "");
  const [user, setUser, loadUser] = useStorage("use", null);

  const [role, setRole] = useStorage("role", "");
  const [id, setId] = useStorage("id", "");
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const [notificationCount, setNotificationCount] = useState(0);

  useEffect(() => {
    // Existing useEffect remains the same
    loadToken();
    loadUser();
    window.scrollTo(0, 0);

    // Add new effect for fetching notification count
    if (user?.id) {
      getData("/notifications?pageNumber=0&pageSize=1")
        .then((res) => {
          setNotificationCount(res.data.pagination.totalRow);
        })
        .catch((error) => {
          console.error("Error fetching notification count:", error);
        });
    }
  }, [currentPath, user?.id]);
  const menuItems = [
    { label: "Home", href: "/" },
    { label: "About", href: "/About" },
    { label: "Retreats", href: "/Retreats" },
    { label: "Forum", href: "/Forums" },
    {
      label: "Visitor guide",
      href: "/visitor-guide",
      // children: [
      //   { label: "Thực tập căn bản", href: "/thuc-tap-can-ban" },
      //   { label: "Đạo Bụt Ứng Dụng", href: "/dao-but-ung-dung" },
      //   { label: "Visitor guide", href: "/visitor-guide" },
      // ],
    },
    { label: "Monastery Visit", href: "/MonasteryVisit" },
    { label: "Offering", href: "/offering" },
    { label: "Contact", href: "/Contact" },
    { label: "Chat", href: "/chat" },

  ];
  return (
    <>
      <header className="bg-white shadow-sm">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <button
              className="text-gray-500 hover:text-gray-600 "
              onClick={toggleMenu}
            >
              <Menu size={24} />
            </button>
            <div className="hidden md:flex space-x-8 items-center">
              {menuItems.map((item) => (
                <div key={item.label} className="relative group">
                  <Link
                    to={item.href}
                    className="text-gray-800 hover:text-red-700 px-3 py-2 text-sm font-medium relative"
                  >
                    {item.label}
                    {item.children && (
                      <span className="absolute bottom-0 left-0 w-full h-0.5 bg-red-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-200" />
                    )}
                  </Link>

                  {item.children && (
                    <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                      <div className="py-1">
                        {item.children.map((child) => (
                          <Link
                            key={child.label}
                            to={child.href}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-red-700"
                          >
                            {child.label}
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
            {/* <nav className="hidden lg:flex space-x-8">
              <Link to="/" className="text-brown-600 hover:text-brown-800">
                Home
              </Link>
              <Link to="/About" className="text-gray-500 hover:text-gray-600">
                About
              </Link>
              <a href="#" className="text-gray-500 hover:text-gray-600">
                Thich Nhat Hanh
              </a>
              <Link
                to="/Retreats"
                className="text-gray-500 hover:text-gray-600"
              >
                Retreats
              </Link>
            </nav> */}
            <div className="flex items-center space-x-4">
              {user?.id ? (
                <></>
              ) : (
                <Link to="/login" className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full text-sm font-medium hover:bg-yellow-200">
                  Login
                </Link>
              )}

              {/* <button className="text-gray-500 hover:text-gray-600">
                <Search size={24} />
              </button> */}
              {user?.id ? (
                <Link
                  to={"/notification"}
                  className="text-gray-500 hover:text-gray-600 relative"
                >
                  <Bell size={24} />
                  {notificationCount > 0 && (
                    <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                      {notificationCount > 99 ? '99+' : notificationCount}
                    </span>
                  )}
                </Link>
              ) : (
                <></>
              )}
              <>
                {token ? (
                  <>
                    <MyMenu as="div" className="relative">
                      <MenuButton className="-m-1.5 flex items-center p-1.5">
                        <span className="sr-only">Open user menu</span>
                        <img
                          alt={user.avatar}
                          src={user.avatar}
                          className="h-8 w-8 rounded-full bg-gray-50"
                        />
                        <span className="hidden md:flex md:items-center">
                          <span
                            aria-hidden="true"
                            className="ml-4 text-sm font-semibold leading-6 text-black"
                          >
                            {/* {user.lastName} */}
                            {user.firstName}
                          </span>
                          <ChevronDownIcon
                            aria-hidden="true"
                            className="ml-2 h-5 w-5 text-gray-400"
                          />
                        </span>
                      </MenuButton>
                      <MenuItems
                        transition
                        className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-wbg-white/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                      >
                        {userNavigation.map((item) => (
                          <MenuItem key={item.name}>
                            {item.name === "Logout" ? (
                              <button
                                onClick={() => {
                                  setToken(""); // Gọi hàm để xoá token khi người dùng chọn "Đăng xuất"
                                  setUser({});
                                  setTimeout(() => {
                                    navigate("/login");
                                  }, 1000);
                                }}
                                className="block px-3 py-1 text-sm leading-6 text-wbg-white data-[focus]:bg-gray-50"
                              >
                                {item.name}
                              </button>
                            ) : (
                              <Link
                                to={item.href}
                                className="block px-3 py-1 text-sm leading-6 text-wbg-white data-[focus]:bg-gray-50"
                              >
                                {item.name}
                              </Link>
                            )}
                          </MenuItem>
                        ))}
                      </MenuItems>
                    </MyMenu>
                  </>
                ) : null}
              </>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="flex ">
            <div className="fixed inset-0 z-50 bg-white w-1/2">
              <div className="flex justify-between items-center p-4">
                <button
                  className="text-gray-500 hover:text-gray-600"
                  onClick={toggleMenu}
                >
                  <X size={24} />
                </button>
                {!user?.id && (
                  <Link
                    to="/login"
                    onClick={toggleMenu}
                    className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full text-sm font-medium hover:bg-yellow-200"
                  >
                    Login
                  </Link>
                )}
              </div>
              <nav className="p-4">
                <Link
                  to="/"
                  className="block py-2 text-xl font-semibold border-b-4 border-yellow-300"
                >
                  Home
                </Link>
                <div className="py-2">
                  <ul>
                    <Link
                      to="/About"
                      className="block py-2 text-xl font-semibold   "
                    >
                      About
                    </Link>
                  </ul>
                  <ul>
                    <Link
                      to="/Retreats"
                      className="block py-2 text-xl font-semibold "
                    >
                      Retreats
                    </Link>
                  </ul>
                  <ul>
                    <Link
                      to="/Forums"
                      className="block py-2 text-xl font-semibold "
                    >
                      Forum
                    </Link>
                  </ul>
                  <ul>
                    <Link
                      to="/visitor-guide"
                      className="block py-2 text-xl font-semibold "
                    >
                      Visitor guide
                    </Link>
                  </ul>
                  {/* <ul>
                    <Link to="/Forums" className="text-xl font-semibold ">
                      Mindfulness
                    </Link>
                  </ul> */}
                  {/* <ul className="mt-2 space-y-2">
                    <li>
                      <Link to="/visitor-guide" className="text-gray-600">
                        Visitor guide
                      </Link>
                    </li>
                    <li>
                      <Link to="/about" className="text-gray-600">
                        Our Hamlets
                      </Link>
                    </li>
                  </ul> */}
                </div>
                <ul>
                  <Link
                    to="/MonasteryVisit"
                    className="block py-2 text-xl font-semibold "
                  >
                    Monastery Visit
                  </Link>
                </ul>

                {/* <Link
                  to="/Retreats"
                  className="block py-2 text-xl font-semibold"
                >
                  Retreats
                </Link> */}
                <Link
                  to="/offering"
                  className="block py-2 text-xl font-semibold"
                >
                  Offering
                </Link>

                <Link
                  to="/Contact"
                  className="block py-2 text-xl font-semibold"
                >
                  Contact
                </Link>
                <Link
                  to="/chat"
                  className="block py-2 text-xl font-semibold"
                >
                  Chat
                </Link>
              </nav>
            </div>
            <div
              onClick={toggleMenu}
              className="fixed inset-0 w-full bg-gray-700 bg-opacity-50 backdrop-blur-md z-40"
            ></div>
          </div>
        )}
      </header>
      {children}
      <footer className=" py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Footer Information */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 border-t border-gray-300 pt-8">
            <div>
              <h3 className="font-semibold mb-4">
                Plum Village Practice Centers
              </h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>
                  <h4 className="font-semibold">Plum Village France</h4>
                  <p>13 Martineau, 33580 Dieulivol, France</p>
                </li>
                <li>
                  <h4 className="font-semibold">Healing Spring Monastery</h4>
                  <p>2 Rue Pascal Jardin, 77510 Verdelot, France</p>
                </li>
                <li>
                  <h4 className="font-semibold">Maison de l'Inspir</h4>
                  <p>8 Rue des Fans, 77510 Villeneuve-sur-Bellot, France</p>
                </li>
                {/* Add more practice centers as needed */}
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-4">Follow Plum Village</h3>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-600 hover:text-gray-800">
                  <Facebook />
                </a>
                <a href="#" className="text-gray-600 hover:text-gray-800">
                  <Instagram />
                </a>
                <a href="#" className="text-gray-600 hover:text-gray-800">
                  <Twitter />
                </a>
                <a href="#" className="text-gray-600 hover:text-gray-800">
                  <Youtube />
                </a>
              </div>
            </div>
            <div>
              <h3 className="font-semibold mb-4">Initiatives</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>Wake Up</li>
                <li>Wake Up Schools</li>
                <li>Happy Farms</li>
                <li>Thich Nhat Hanh Foundation</li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-4">Publishing</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>Parallax Press</li>
                <li>The Mindfulness Bell</li>
                <li>Plum Village App</li>
                <li>Podcasts</li>
              </ul>
            </div>
          </div>

          {/* Legal Links */}
          <div className="border-t border-gray-300 mt-8 pt-8 text-sm text-gray-600">
            <ul className="flex flex-wrap justify-center space-x-4">
              <li>
                <a href="#" className="hover:underline">
                  Terms and Conditions
                </a>
              </li>
              <li>
                <a href="#" className="hover:underline">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="hover:underline">
                  Press & Media
                </a>
              </li>
              <li>
                <a href="#" className="hover:underline">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="#" className="hover:underline">
                  Cookie Settings
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Header;
